import { SORT_ORDER } from 'constants.js'

export enum REVENUE_SORT_COLUMNS {
  AVG_VALUE_CLUB = 'transactionValueClubCurrent',
  CHANGED_COMPARED = 'changedCompared',
  CHANNEL_STORE_NAME = 'channelStoreName',
  CLUB_REVENUE = 'revenueClubCurrent',
  CLUSTER = 'cluster',
  CONCEPT = 'concept',
  CONTRIBUTION = 'contribution',
  CONVERSION = 'conversionCurrent',
  DATA_SOURCE = 'dataSource',
  DIFFERENCE = 'difference',
  ESIZE = 'esize',
  ESIZED_CURRENT = 'esizedCurrent',
  ESIZEME_SHARE_CURRENT = 'esizemeShareCurrent',
  EXPOS_TIMESTAMP = 'exposTimestamp',
  EXPRESS = 'express',
  FAIR = 'fair',
  L4L = 'isL4L',
  MARGIN = 'marginCurrent',
  MARGIN_VALUE = 'marginValueCurrent',
  NEW_CARDS = 'clubCardsCurrent',
  ORDER_VALUE = 'orderValue',
  ORDERS = 'orders',
  ORDERS_SHARE = 'orders[share]',
  ORDERS_VALUE = 'ordersValue',
  ORDERS_VALUE_SHARE = 'ordersValue[share]',
  PERCENT_REVENUE_CLUB = 'percentRevenueClub',
  PROMOTION = 'promotion',
  REPLENISHMENT_OTHERS = 'replenishmentOnHandOthersCurrent',
  REPLENISHMENT_SHOES = 'replenishmentOnHandShoesCurrent',
  RESA_TIMESTAMP = 'resaTimestamp',
  RETURNS = 'returnsValueCurrent',
  REVENUE_CURRENT_PLN = 'revenueCurrentPLN',
  RETURNS_SHARE = 'returnsValueShareCurrent',
  SALE_WITHOUT_RETURNS = 'saleWithoutReturns',
  SPACE_CHANGE = 'spaceChange',
  STORE_ID = 'storeId',
  STORE_NAME = 'storeName',
  TEMPERATURE = 'temperatureCurrent',
  TRAFFIC = 'trafficCurrent',
  TRAFFIC_TIMESTAMP = 'trafficTimestamp',
  REVENUE_PERCENT = 'revenuePercent',
  REVENUE_PERCENT_QTD = 'revenuePercentQtd',
  REVENUE_PERCENT_YTD = 'revenuePercentYtd',
}

export const ALL_STORES_COUNTRY_ID = 'all'

export const DEFAULT_SORT_BY = {
  value: REVENUE_SORT_COLUMNS.REVENUE_CURRENT_PLN,
  order: SORT_ORDER.ASC,
}

export const dataSourceOptions = [
  { key: 'R', description: 'Resa' },
  { key: 'U', description: 'Utargi' },
  { key: 'T', description: 'Traffic' },
  { key: 'L', description: 'Last Year' },
]
